export const state = () => ({
  info: {},
  pageList: [],
  storeGoods: [],
  shopGood: {} // 待购买商品
})

export const mutations = {
  SET_INFO(state, info) {
    state.info = info
  },
  SET_PAGE_LIST(state, data) {
    state.pageList = data
  },
  SET_STORE_GOODS(state, data) {
    state.storeGoods = data
  },
  SET_SHOP_GOOD(state, data) {
    state.shopGood = data
  }
}
